<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Geral">
        <NxInput
        name="nome"
        type="text"
        label="Nome do Produto:"
        placeholder="Digite o nome"
        @update:value="handleInputUpdate('nome', $event)"
      ></NxInput>
        <NxInput
          name="codigo"
          type="text"
          label="Código:"
          placeholder="Digite o código"
          @update:value="handleInputUpdate('codigo', $event)"
        ></NxInput>
      </SearchCollapse>
      <!-- codigo=2323&nome=ada -->
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'

export default {
  name: 'SidebarProduto',
  components: { SidebarSearch, SearchCollapse },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        codigo: null
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/product/components/search/SidebarProduto.vue